import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_HOUSEKEEPER_CORE_URL}/api`
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
instance.interceptors.request.use(reqConfig => {
  if (Vue.prototype.$getCookie('comLoginToken')) {
    const xCorrelationId = Vue.prototype.$getGuid()
    reqConfig.headers = {
      KingnetAuth: 'Cookies ' + Vue.prototype.$getCookie('comLoginToken').split('token=').pop(),
      'X-Correlation-Id': xCorrelationId
    }
    Sentry.setTag('X-Correlation-Id', xCorrelationId)
  }
  return reqConfig
}, err => {
  return Promise.reject(err)
})
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403)) {
      // eslint-disable-next-line eqeqeq
      if (err.response.data.Message !== undefined && err.response.status == 401) {
        Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          router.push({ name: 'LoginMain' })
        })
        return Promise.reject(err)
      // eslint-disable-next-line eqeqeq
      } else if (err.response.data.Message !== undefined && err.response.status == 403) {
        Vue.prototype.$alert(`${err.response.data.Message}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          Vue.prototype.$toMainPage()
        })
        return Promise.reject(err)
      }
    } else {
      return Promise.reject(err)
    }
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/Calendar
export const apiCalendar = {
  GetAnnualEventList: (requestData, config) => instance.get('/v1/Calendar/AnnualEvents', Object.assign({}, { params: requestData }, config)), // 取得年度活動列表
  PostCreateEvent: (requestData, config) => instance.post('/v1/Calendar/Event', requestData, config), // 建立活動
  PostUploadEventFile: (requestData, config) => instance.post('/v1/Calendar/Event/File', requestData, config), // 活動上傳檔案換url
  GetRecentColor: (config) => instance.get('/v1/Calendar/RecentColor', config), // 取得活動常用顏色
  PatchUpdateEvent: (requestData, config) => instance.patch(`/v1/Calendar/Event/${requestData.Id}`, requestData, config), // 編輯活動
  DeleteEvent: (requestData, config) => instance.delete(`/v1/Calendar/Event/${requestData.eventId}`, Object.assign({}, { params: requestData }, config)) // 刪除活動
}
